import BaseService from './base.service'

class BonusService extends BaseService {
    getBonusPageContent() {
        return new Promise((resolve, reject) => {
            return this.request()
                .post({
                    method: 'Bonus.getBonusPageContent',
                })
                .then(response => resolve(response.data?.response))
                .catch(error => reject(this.errorWrapper(error.response)))
        })
    }
}

export default new BonusService()
